import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTable, Filter, FilterTag } from "../../../../../../../components";
import rebateModeEnum from "../../../../../../../enumerations/rebateModeEnum";
import { moneyFormat } from "../../../../../../../plugins/numberFormat";
import { getCurrency } from "../../../../../../../plugins/utils";
import { filterKey } from "../../enumerations/filterKeyEnum";
import { filterSetup } from "../../enumerations/filterSetupEnum";
import { useGetDownlineFirstDeposit } from "../../hooks/downlinedetail.hooks";
const CURRENCY = getCurrency();

const FirstDeposit = ({ startAt = null, endAt = null, rebateMode = undefined }) => {
  const { t } = useTranslation();

  const [localData, setLocalData] = useState([]);
  const [filterDefaultValue, setFilterDefaultValue] = useState({
    [filterKey.ACCOUNT]: "",
    [filterKey.AGENT_ACCOUNT]: "",
    [filterKey.LEVEL]: "all",
  });
  const [filterValue, setFilterValue] = useState({
    [filterKey.ACCOUNT]: "",
    [filterKey.AGENT_ACCOUNT]: "",
    [filterKey.LEVEL]: "all",
  });

  const {
    data: firstDeposit,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isLoading,
    isError,
  } = useGetDownlineFirstDeposit({
    params:
      rebateMode !== rebateModeEnum.WINLOSE
        ? {
            start_at: startAt,
            end_at: endAt,
            ...filterValue,
          }
        : {
            start_at: startAt,
            end_at: endAt,
          },
    options: {
      getNextPageParam: (lastPage, pages) => {
        if (pages.length < lastPage.last_page) {
          return pages.length + 1;
        } else {
          return undefined;
        }
      },
    },
    enabled: startAt !== null && endAt !== null,
  });

  const loadMore = () => {
    if (isFetchingNextPage === false && localData.length > 0) {
      fetchNextPage();
    }
  };
  const onHandleSearch = () => {};

  useEffect(() => {
    if (firstDeposit) {
      const page_length = firstDeposit.pages.length;
      if (page_length <= 1) {
        setLocalData([...firstDeposit.pages[0].data]);
      } else {
        setLocalData((prevState) => {
          return [...prevState, ...firstDeposit.pages[page_length - 1].data];
        });
      }
    }
  }, [firstDeposit]);

  const columns = [
    {
      title: t("normal.date"),
      width: 100,
      valueType: "dateTime",
      dataIndex: "date",
      align: "center",
    },
    {
      title: t("normal.account"),
      width: 240,
      dataIndex: "account",
      align: "center",
    },
    {
      title: t("normal.level"),
      width: 100,
      dataIndex: "level",
      align: "center",
      hideInTable: rebateMode === rebateModeEnum.WINLOSE,
    },
    {
      title: t("normal.agent.account"),
      width: 240,
      dataIndex: "agent_account",
      align: "center",
      hideInTable: rebateMode === rebateModeEnum.WINLOSE,
    },
    {
      title: t("normal.uid"),
      width: 100,
      dataIndex: "account_id",
      align: "center",
    },
    {
      title: `${t("normal.amount")} (${t(`global.currency.${CURRENCY}`)})`,
      width: 100,
      dataIndex: "today_first_deposit_amount",
      align: "center",
      render: (text, record, index) => {
        return <>{moneyFormat(text)}</>;
      },
    },
  ];

  const renderFilter = () => {
    if (rebateMode && rebateMode !== rebateModeEnum.WINLOSE) {
      return (
        <>
          <Filter
            filterSetup={filterSetup}
            filterDefaultValue={filterDefaultValue}
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            onReset={() => {
              //if need some aditional reset logic in the page
              console.debug("RESET FILTER");
            }}
            onSubmitSearch={onHandleSearch}
          />
          <FilterTag
            filterSetup={filterSetup}
            filterValue={filterValue}
            filterDefaultValue={filterDefaultValue}
            setFilterValue={setFilterValue}
            refreshSearch={onHandleSearch}
          />
        </>
      );
    }
    return null;
  };

  return (
    <div>
      {renderFilter()}
      {isLoading ? (
        ""
      ) : isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={localData}
          hasMore={hasNextPage}
          loadMore={loadMore}
          showInifineScroll={true}
        />
      )}
    </div>
  );
};

export default FirstDeposit;
